<template>
  <div class="flex p-1.5 rounded-full bg-grey-light-50 border border-grey-light-200 w-fit mx-auto">
    <div
      v-for="product in products"
      :key="product.name"
      @click="onSelectProduct(product.name)"
      :class="[
        'flex items-center justify-center rounded-full py-2 px-6 hover:cursor-pointer',
        themeStore.current === product.name ? 'bg-primary custom-shadow' : '',
      ]"
    >
      <div class="h-[30px] flex items-center justify-center">
        <img
          :class="product.name === 'boost' ? 'h-[29px] w-20' : 'mt-1'"
          :src="themeStore.current === product.name ? product.logoWhite : product.logoGrey"
          :alt="product.alt"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import boostGrey from '@/assets/images/boost-logo-grey.svg';
import boostWhite from '@/assets/images/boost-logo-white.svg';
import laybyGrey from '@/assets/images/layby-logo-grey.svg';
import laybyWhite from '@/assets/images/layby-logo-white.svg';
import { useThemeStore } from '@/stores/theme';
import { useRouter } from 'vue-router';

const themeStore = useThemeStore();
const router = useRouter();

const products: { name: 'layby' | 'boost'; logoWhite: string; logoGrey: string; alt: string }[] = [
  {
    name: 'layby',
    logoWhite: laybyWhite,
    logoGrey: laybyGrey,
    alt: 'Layby Logo',
  },
  {
    name: 'boost',
    logoWhite: boostWhite,
    logoGrey: boostGrey,
    alt: 'Boost Logo',
  },
];

const onSelectProduct = (productName: 'layby' | 'boost') => {
  themeStore.setProduct(productName);

  const currentPath = router.currentRoute.value.path;
  const fromProduct = productName === 'layby' ? 'boost' : 'layby';
  const toProduct = productName === 'layby' ? 'layby' : 'boost';
  const newPath = currentPath.replace(fromProduct, toProduct);

  router.push(newPath);
};
</script>

<style scoped>
.custom-shadow {
  box-shadow:
    0 1.07px 3.21px rgba(16, 24, 40, 0.1),
    0 1.07px 2.14px rgba(16, 24, 40, 0.06);
}
</style>
